import React from 'react';
import SupportRow from './SupportRow';

const SupportSection = ({ id, title, description, rows }) => (
  <section id={id} className="support-section">
    <h2 className="support-section-title">{title}</h2>
    <p className="support-section-description">{description}</p>
    {rows.map((row) => (
      <SupportRow key={row.issue} issue={row.issue} solution={row.solution} />
    ))}
  </section>
);

export default SupportSection;
